module.exports = __webpack_public_path__ + "static/img/four.52726c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/infoService/1/four.png
// module id = wiL7
// module chunks = 1